import script from "./UnifiedTwoFaVerificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnifiedTwoFaVerificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./UnifiedTwoFaVerificationModal.vue?vue&type=style&index=0&id=3325cfc9&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3325cfc9"]])

export default __exports__